"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var LoanoutResource = /** @class */ (function (_super) {
    tslib_1.__extends(LoanoutResource, _super);
    function LoanoutResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoanoutResource.endpoint = '/loanouts';
    LoanoutResource.MODEL_NAME = 'loanout';
    return LoanoutResource;
}(base_1.default));
exports.default = LoanoutResource;
//# sourceMappingURL=loanout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/loanout.js
// module id = ck+T
// module chunks = 0